import React, { Component } from 'react';
import { connect, FormikContext } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { IExamActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-exam-content';
import { DatetimeFormik } from '../../../../components/input/date-time/date-time-formik';
import { Quil } from '../../../../components/input/quil/main';
import { SelectAsync, SelectNoneAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { FileUpload } from '../../../../components/file-upload/main';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Confirm } from '../../../../components/notification/main';
import Switch from 'react-switch';
import { Common } from '../../../../core/common';
import { ExamScoringType } from '../../../../models/enums/ExamScoringType';
import { ExamQuestionWeightingType } from '../../../../models/enums/ExamQuestionWeightingType';
import { ExamService } from '../../../../api/exam-service';
import { IDifficultiesQuestionCount, IExamDifficulties, IExamQuestionWeights, ITopicsQuestionCount } from '../../../../models/action/exam';
import { IExamQuestionWeightProps, IExamQuestionWeightState } from '../../../../models/components/add-activity-exam-question-weight';

const T = Translator.create();
const _logger = Log.create('Exam Add Question Weight');
let _common: Common;
const _examService = new ExamService();

let isTrigger = false;

export class QuestionWeight extends Component<IExamQuestionWeightProps, IExamQuestionWeightState> {
    state: IExamQuestionWeightState = {
        difficultyDatas: [],
        topicDatas: [],
        topicQuestions: [],
        difficultyQuestions: [],
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public getDifficultyDatas = async () => {
        const params = { courseId: this.props.coursePageActivityId };
        const difficultyDatas: Response = await _examService.RequestGetDifficultiesQuestionCountAsync(params);
        this.examQuestionWeightingTypeHandleChange();
        this.setState({ difficultyDatas: await difficultyDatas.json() });
    };

    async componentDidMount() {
        const { isUpdate, formik } = this.props;
        const { examQuestionWeights } = formik.values;

        if (
            isUpdate &&
            examQuestionWeights &&
            examQuestionWeights?.length &&
            !(this?.state?.topicDatas && this?.state?.topicDatas?.length)
        ) {
            isTrigger = true;
        }

        await this.getDifficultyDatas();
    }


    componentDidUpdate(prevProps: Readonly<IExamQuestionWeightProps>, prevState: Readonly<IExamQuestionWeightState>, snapshot?: any): void {
        if (this.state.difficultyDatas !== prevState.difficultyDatas) {
            this.setState({ difficultyQuestions: this.state.difficultyDatas })
        }
    }

    questionCountCheck = (value: number, maxValue: number) => {
        return value >= 1 && value <= maxValue;
    }

    public onChange = (target: EventTarget & HTMLInputElement, formik: FormikContext<IOuterProps>, maxCount: number) => {
        let examQuestionWeights: IExamQuestionWeights[] | undefined = formik.values.examQuestionWeights;
        const examDifficulties: string[] | undefined = formik.values.examDifficulties;
        const examTopics: string[] | undefined = formik.values.examTopics;

        if ((examTopics && examTopics?.length) || (examDifficulties && examDifficulties?.length)) {
            const targetId: string = target.name.split('_')[0];
            const targetType: string = target.name.split('_')[1];
            const targetValue: number = target.valueAsNumber;

            let weight: IExamQuestionWeights | undefined;
            if (examQuestionWeights && examQuestionWeights?.length) {
                weight = examQuestionWeights.find(w => w.id === targetId);

                if (weight) {
                    if (targetType === 'count') {
                        weight.count = targetValue;
                    } else {
                        weight.score = targetValue;
                    }
                } else {
                    if (targetType === 'count') {
                        weight = { id: targetId, score: 0, count: targetValue, maxCount: maxCount };
                    } else {
                        weight = { id: targetId, score: targetValue, count: 0, maxCount: maxCount };
                    }

                    examQuestionWeights.push(weight);
                }
            } else {
                if (targetType === 'count') {
                    examQuestionWeights = [{ id: targetId, score: 0, count: targetValue, maxCount: maxCount }];
                } else {
                    examQuestionWeights = [{ id: targetId, score: targetValue, count: 0, maxCount: maxCount }];
                }
            }
            formik.setFieldValue('examQuestionWeights', examQuestionWeights);
        }
    };

    public getValue = (id: string, type: string) => {
        const examQuestionWeights: IExamQuestionWeights[] | undefined = this.props.formik.values.examQuestionWeights;
        if (examQuestionWeights && examQuestionWeights?.length > 0) {
            const weight = examQuestionWeights.find(w => w.id === id);
            if (weight) {
                if (type === 'count') {
                    return weight.count;
                } else {
                    return weight.score;
                }
            }
        }
        return 0;
    };

    public topicHandleChange = (e: any) => {
        const topicDatas: ITopicsQuestionCount[] = [];
        const ids: string[] = [];
        const idsAndLabels = [];
        const tempTopicDatas: ITopicsQuestionCount[] = [];
        const tempTopicQuestions: any = [];

        if (e && e?.length) {
            e.map((data: any) => {
                topicDatas.push({ id: data.value, label: data.label, count: data.count });
                tempTopicQuestions.push({ id: data.value, count: data.count });
                ids.push(data.value);
                idsAndLabels.push({ id: data.value, label: data.label });
            });

            this.props.formik.setFieldValue('examTopics', ids);
            if (this.props.formik.values.examQuestionWeights) {
                if (isTrigger) {
                    e.map((data: any) => {
                        this.props.formik.values.examQuestionWeights!.map(item => {
                            if (data.value === item.id) {
                                tempTopicDatas.push({ id: data.value, label: data.label, count: item.count });
                            }
                        });
                    });
                    this.setState({ topicDatas: tempTopicDatas });
                }
                this.props.formik.setFieldValue(
                    'examQuestionWeights',
                    this.props.formik.values.examQuestionWeights.filter(weight => ids.indexOf(weight.id) !== -1)
                );
            }
        } else {
            this.props.formik.setFieldValue('examQuestionWeights', []);
        }
        if (!isTrigger) {
            this.setState({ topicDatas });
        }
        this.setState({ topicQuestions: tempTopicQuestions })
        isTrigger = false;
    };

    public difficulyHandleChange = (e: any) => {
        const ids: string[] = [];
        // if (e && e.length) {
        //     e.map((data: any) => {
        //         ids.push(data.value);
        //     });

        //     this.props.formik.setFieldValue('examDifficulties', ids);
        //     if (this.props.formik.values.examQuestionWeights) {
        //         this.props.formik.setFieldValue(
        //             'examQuestionWeights',
        //             this.props.formik.values.examQuestionWeights.filter(weight => ids.indexOf(weight.id) !== -1)
        //         );
        //     }
        // } else {
        //     this.props.formik.setFieldValue('examQuestionWeights', []);
        // }
    };

    public examQuestionWeightingTypeHandleChange = (e?: any) => {
        if (e && e.value === ExamQuestionWeightingType.Difficulty) {
            this.props.formik.setFieldValue('examTopics', null);
        } else if (e && e.value === ExamQuestionWeightingType.Topic) {
            this.props.formik.setFieldValue('examDifficulties', null);
        }
        this.props.formik.setFieldValue('examQuestionWeights', []);
        this.props.formik.setFieldValue('examQuestionWeightingType', e ? e.value : -1);
    };

    public render() {
        const examQuestionWeightingTypeOptions = [
            { value: ExamQuestionWeightingType.None, label: T.t('r_exam_question_weighting_type_None') },
            { value: ExamQuestionWeightingType.Difficulty, label: T.t('r_exam_question_weighting_type_Difficulty') },
            { value: ExamQuestionWeightingType.Topic, label: T.t('r_exam_question_weighting_type_Topic') },
        ];

        const { examQuestionWeightingType, examDifficulties, examTopics } = this.props.formik.values;
        const isDifficultyType = examQuestionWeightingType === ExamQuestionWeightingType.Difficulty;
        const isTopicType = examQuestionWeightingType === ExamQuestionWeightingType.Topic;

        return (
            <>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <h5 style={{ marginBottom: 20 }}>{T.t('r_add_exam_question_weighting_type')}</h5>
                        <SelectNoneAsync
                            isMulti={false}
                            name="examQuestionWeightingType"
                            touched={this.props.formik.touched.examQuestionWeightingType}
                            errors={this.props.formik.errors.examQuestionWeightingType}
                            setFieldValue={this.props.formik.setFieldValue}
                            setOptions={examQuestionWeightingTypeOptions}
                            onChange={this.examQuestionWeightingTypeHandleChange}
                            isTouched={this.props.formik.setFieldTouched}
                            placeHolder={T.t('r_add_exam_select_exam_question_weighting_type')}
                            setSelectValue={this.props.isUpdate ? [examQuestionWeightingType] : [-1]}
                            disable={this.props.isExamPublished}
                        />
                    </div>
                </div>

                {isDifficultyType && (
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <h5 style={{ marginBottom: 20 }}>{T.t('r_add_exam_question_weighting_difficulty')}</h5>
                            <SelectAsync
                                isMulti={true}
                                requestType="post"
                                parameter={{}}
                                placeHolder={T.t('r_add_exam_question_weighting_difficulty_select')}
                                url="api/exam/difficulty/get"
                                closeMenuOnScroll={false}
                                closeMenuOnSelect={false}
                                setSelectValue={this.props.isUpdate ? examDifficulties : ''}
                                name="examDifficulties"
                                value={examDifficulties}
                                onChange={this.difficulyHandleChange}
                                setFieldValue={this.props.formik.setFieldValue}
                                errors={this.props.formik.errors.examDifficulties}
                                touched={this.props.formik.touched.examDifficulties}
                                isTouched={this.props.formik.setFieldTouched}
                                hasLocalization={true}
                                setFieldOnlyValue={true}
                                triggerOnChangeOnUpdate={true}
                                isDisabled={this.props.isExamPublished}
                            />
                        </div>
                    </div>
                )}

                {isTopicType && (
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <h5 style={{ marginBottom: 20 }}>{T.t('r_add_exam_question_weighting_topic')}</h5>
                            <SelectAsync
                                isMulti={true}
                                isSearchable={true}
                                requestType="post"
                                parameter={{
                                    SearchedText: '',
                                    CourseId: this.props.coursePageActivityId,
                                    SelectedIds: examTopics,
                                }}
                                placeHolder={T.t('r_add_exam_question_weighting_topic_select')}
                                url="api/exam/topic/get"
                                closeMenuOnScroll={false}
                                closeMenuOnSelect={false}
                                setSelectValue={this.props.isUpdate ? examTopics : ''}
                                name="examTopics"
                                value={examTopics}
                                onChange={this.topicHandleChange}
                                setFieldValue={this.props.formik.setFieldValue}
                                errors={this.props.formik.errors.examTopics}
                                touched={this.props.formik.touched.examTopics}
                                isTouched={this.props.formik.setFieldTouched}
                                hasLocalization={true}
                                setFieldOnlyValue={true}
                                onChangeRequest={true}
                                triggerOnChangeOnUpdate={true}
                                isDisabled={this.props.isExamPublished}
                            />
                        </div>
                    </div>
                )}

                {(isDifficultyType || isTopicType) && (
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <h5 style={{ marginBottom: 20 }}>{T.t('r_add_exam_question_weighting')}</h5>
                            {(isDifficultyType && examDifficulties?.length) || (isTopicType && examTopics?.length) ? (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>{T.t('r_add_exam_difficult')}</th>
                                            <th>{T.t('r_add_exam_table_count')}</th>
                                            <th>{T.t('r_add_exam_table_score')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isDifficultyType && examDifficulties?.map((diff: string, index: any) => {
                                            const stateDiff = this.state.difficultyDatas?.find(d => d.id === diff);
                                            const stateQuestion = this.state.difficultyQuestions?.find((question: { id: string; count: number; }) => question.id === diff);

                                            return (
                                                stateDiff && (
                                                    <tr key={index}>
                                                        <td>
                                                            <label style={{ fontSize: 15, color: '#666' }}>
                                                                {T.t(stateDiff.label)}
                                                            </label>
                                                            {stateQuestion && (
                                                                <p style={{ fontSize: 14, color: '#a74a4a' }}>
                                                                    {T.t('r_add_exam_table_difficulty_count')}{stateQuestion.count}
                                                                </p>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="form-input form-group">
                                                                <input
                                                                    type="number"
                                                                    name={`${stateDiff.id}_count`}
                                                                    data-label={stateDiff.label}
                                                                    value={this.getValue(stateDiff.id, 'count')}
                                                                    onChange={e => this.onChange(e.target, this.props.formik, stateQuestion?.count)}
                                                                    disabled={this.props.isExamPublished}
                                                                    style={{ borderBottom: this.questionCountCheck(this.getValue(stateDiff.id, 'count'), stateQuestion.count) ? "1px solid #39b27b" : "1px solid #ff6f61" }}
                                                                    onFocus={e => {
                                                                        if (e.target.value === "0" || e.target.value === "") {
                                                                            e.target.value = "";
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="form-input form-group">
                                                                <input
                                                                    type="number"
                                                                    name={`${stateDiff.id}_score`}
                                                                    data-label={stateDiff.label}
                                                                    value={this.getValue(stateDiff.id, 'score')}
                                                                    onChange={e => this.onChange(e.target, this.props.formik, stateQuestion?.count)}
                                                                    disabled={this.props.isExamPublished}
                                                                    onFocus={e => {
                                                                        if (e.target.value === "0" || e.target.value === "") {
                                                                            e.target.value = "";
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            );
                                        })}

                                        {isTopicType && examTopics?.map((topicId: string, index: number) => {
                                            const topicData = this.state.topicDatas.find(d => d.id === topicId);
                                            const topicQuestion = this.state.topicQuestions.find((question: { id: string; count: number; }) => question.id === topicId);

                                            if (!topicData || !topicQuestion) return null;

                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <label style={{ fontSize: 15, color: '#666' }}>
                                                            {T.t(topicData.label)}
                                                        </label>
                                                        <p style={{ fontSize: 14, color: '#a74a4a' }}>
                                                            {T.t('r_add_exam_table_topic_count')}{topicQuestion.count}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <div className="form-input form-group">
                                                            <input
                                                                type="number"
                                                                name={`${topicData.id}_count`}
                                                                data-label={topicData.label}
                                                                value={this.getValue(topicData.id, 'count')}
                                                                onChange={e => this.onChange(e.target, this.props.formik, topicQuestion.count)}
                                                                disabled={this.props.isExamPublished}
                                                                style={{
                                                                    borderBottom: this.questionCountCheck(this.getValue(topicData.id, 'count'), topicQuestion.count)
                                                                        ? "1px solid #39b27b"
                                                                        : "1px solid #ff6f61"
                                                                }}
                                                                onFocus={e => {
                                                                    if (e.target.value === "0" || e.target.value === "") {
                                                                        e.target.value = "";
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="form-input form-group">
                                                            <input
                                                                type="number"
                                                                name={`${topicData.id}_score`}
                                                                data-label={topicData.label}
                                                                value={this.getValue(topicData.id, 'score')}
                                                                onChange={e => this.onChange(e.target, this.props.formik, 48)}
                                                                disabled={this.props.isExamPublished}
                                                                onFocus={e => {
                                                                    if (e.target.value === "0" || e.target.value === "") {
                                                                        e.target.value = "";
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            ) : (
                                <p>{T.t('r_add_exam_required_weighting')}</p>
                            )}
                        </div>
                    </div>
                )}
            </>
        );
    }

}
